export default __webpack_public_path__ + "static/media/WM0340.34I-41305_-24649_0.54312450.jpg";